import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectActiveParty, selectParty } from '../../Redux/slices/partyState'
import ScrollToTargetAdjusted from '../../Utils/ScrollToTargetAdjusted'
import AddParty from './AddParty'
import PartyTransactionRecord from './PartyTransactionRecord'
import UpdateParty from './UpdateParty'
import ViewParties from './ViewParties'

export default function ManageParty() {
  const dispatch = useDispatch()
  const activeParty = useSelector(selectActiveParty)
  const [editParty,setEditParty] = useState({docid:false})
  function setEditHandler(form){

    return ()=>{
      setEditParty(form)
      dispatch(selectParty(false))
      ScrollToTargetAdjusted("updatePartyForm")
    }
  }
  return (
    <div className='w-full flex flex-col'>

        <AddParty/>
        <ViewParties setEditHandler={setEditHandler}/>
        {editParty.docid&&<UpdateParty formData={editParty} setFormData={setEditParty} setEditHandler={setEditHandler}/>}
        {activeParty&&<PartyTransactionRecord partyId={activeParty}/>}
       

    </div>
  )
}
